import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const createExamRoomPortal = async (data) => {
  const res = await axiosInstance.post("/exam-seating-portal/rooms/create", data);
  return res.data;
};

export const getAllExamRoomsPortal = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/exam-seating-portal/rooms/all${qs(filters)}`
  );
  return res.data;
};

export const getExamRoomByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/exam-seating-portal/rooms/${id}`);
  return res.data;
};

export const updateExamRoomPortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/exam-seating-portal/rooms/update/${id}`,
    data
  );
  return res.data;
};

export const deleteExamRoomPortal = async (id) => {
  const res = await axiosInstance.delete(
    `/exam-seating-portal/rooms/delete/${id}`
  );
  return res.data;
};

export const createSeatingPlanPortal = async (data) => {
  const res = await axiosInstance.post("/exam-seating-portal/create", data);
  return res.data;
};

export const getAllSeatingPlansPortal = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-seating-portal/all${qs(filters)}`);
  return res.data;
};

export const getSeatingPlanByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/exam-seating-portal/${id}`);
  return res.data;
};

export const getSeatingPlanBySchedulePortal = async (scheduleId) => {
  const res = await axiosInstance.get(
    `/exam-seating-portal/by-schedule/${scheduleId}`
  );
  return res.data;
};

export const getStudentsForSeatingPortal = async (scheduleId, filters = {}) => {
  const res = await axiosInstance.get(
    `/exam-seating-portal/students-for-schedule/${scheduleId}${qs(filters)}`
  );
  return res.data;
};

export const updateSeatingPlanPortal = async (id, data) => {
  const res = await axiosInstance.put(
    `/exam-seating-portal/update/${id}`,
    data
  );
  return res.data;
};

export const updateSeatingPlanStatusPortal = async (id, status) => {
  const res = await axiosInstance.put(
    `/exam-seating-portal/status/${id}`,
    { status }
  );
  return res.data;
};

export const deleteSeatingPlanPortal = async (id) => {
  const res = await axiosInstance.delete(`/exam-seating-portal/delete/${id}`);
  return res.data;
};
